declare global {
  interface Window {
    BE_URL: string;
  }
}

const API_PREFIX = window.BE_URL + "/api/v1";
export const API_URL = {
  AUTH: API_PREFIX + "/login",
  LOGOUT: API_PREFIX + "/logout",
  JD_LIST: API_PREFIX + "/jd/list",
  JOB_ROLE_LIST: API_PREFIX + "/static/job-roles",
  FEEDBACKS_LIST: API_PREFIX + "/static/feedbacks",
  VENDORS_LIST: API_PREFIX + "/static/vendors",
  AUDIT_TYPES_LIST: API_PREFIX + "/static/audit-types",
  AUDITEES_LIST: API_PREFIX + "/static/auditees",
  TEAMLEAD_LIST: API_PREFIX + "/static/team-members",
  TEAM_MEMBERS_LIST: API_PREFIX + "/static/team-members",

  AUDIT_MODES_LIST: API_PREFIX + "/static/audit-modes",
  TEAMS_LIST: API_PREFIX + "/static/all-teams",
  JD_CREATE: API_PREFIX + "/jd/create",
  JD_UPDATE: API_PREFIX + "/jd/update",
  JD_VIEW: API_PREFIX + "/jd/view",
  JD_BY_ROLE: API_PREFIX + "/jd/role",
  JD_DELETE: API_PREFIX + "/jd/delete",
  CREATE_ROLE_REQUEST: API_PREFIX + "/role-request/create",
  CREATE_AUDIT_PLANNING: API_PREFIX + "/auditing/create",
  UPDATE_AUDIT_PLANNING: API_PREFIX + "/auditing/update",
  KICKOFF_MEETING: API_PREFIX + "/auditing/schedule-meeting",

  AUDITING_LIST: API_PREFIX + "/auditing/list",
  DELETING_LIST: API_PREFIX + "/auditing/delete",
  KICKOFF_LIST: API_PREFIX + "/auditing/kickoff-scheduled/list",
  ATTENDEES_LIST: API_PREFIX + "/auditing/attendees/list",
  QUESTIONS_LIST: API_PREFIX + "/audit-question/regulatory-frameworks-list",
  SEND_AUDTI_QUESTIONS: API_PREFIX + "/audit-question/send",
  REVIEW_LIST: API_PREFIX + "/auditing/review/list",
  IN_REVIEW_LIST: API_PREFIX + "/auditing/in-review/list",
  AI_COMPLAINCE: API_PREFIX + "/audit-planning-analysis/suggest",
  COMEPLETED_LIST: API_PREFIX + "/auditing/completed/list",
  AUDIT_CLOSURE_LIST: API_PREFIX + "/auditing/closure/list",
  OVERVIEW_LIST: API_PREFIX + "/auditing/overView/list",
  AUDITING_REVIEW: API_PREFIX + "/auditing/inReview",
  AUDITING_CLOSE: API_PREFIX + "/auditing/completed",
  AUDITING_MOVE_CLOSURE: API_PREFIX + "/auditing/closure",

  AUDIT_REVIEW_DETAILS: API_PREFIX + "/auditing/view",
  QUESTIONS_RESPONSE: API_PREFIX + "/audit-question/review",
  AUDIT_REPORT: API_PREFIX + "/audit-question/report",
  AUDIT_SEQUENCE_LIST: API_PREFIX + "/static/sequence",
  AI_SUGGESTIONS: API_PREFIX + "/audit-question/ai-suggestion",
  AI_OBSERVATION: API_PREFIX + "/audit-question/ai-analysis-observation",

  AUDIT_ORGINIZATION: API_PREFIX + "/static/organizations",
  AUDIT_ORGTHEME: API_PREFIX + "/static/themes",
  AUDIT_ORGAPPLICATION: API_PREFIX + "/static/organization-applications",
  AUDIT_ORGMEMBER: API_PREFIX + "/static/organization-members",

  ROLE_REQUEST_VIEW: API_PREFIX + "/role-request/view",
  UPDATE_SQUAD: API_PREFIX + "/role-request/update-squad",
  AI_CHAT_BOT_API: API_PREFIX + "/chat/query",

  VENDOR_LIST: API_PREFIX + "/vendor/list",
  VENDOR_CREATE: API_PREFIX + "/vendor/create",
  VENDOR_VIEW: API_PREFIX + "/vendor/view",
  VENDOR_UPDATE: API_PREFIX + "/vendor/update",
  VENDOR_DELETE: API_PREFIX + "/vendor/delete",
  USER_DELETE: API_PREFIX + "/user/delete",
  USERS_LIST: API_PREFIX + "/user/list",
  USERS_LIST_BY_ROLE: API_PREFIX + "/user/list/role",
  USERS_REGISTER: API_PREFIX + "/user/register",
  USER_GROUPS: API_PREFIX + "/user/groups",
  USER_GROUPS_LIST: API_PREFIX + "/user/groups/list",
  USER_GROUPS_REGISTER: API_PREFIX + "/user/groups/register",
  ROLE_MAPPING_ROLES: API_PREFIX + "/user/list/roles",
  TEAM_LIST: API_PREFIX + "/user/team/list",
  TEAM_CREATE: API_PREFIX + "/user/team/create",
  TEAM_UPDATE: API_PREFIX + "/user/team/update",
  TEAM_DELETE: API_PREFIX + "/user/team/delete",
  UPDATE_USER_STATUS: API_PREFIX + "/user/update/status",
  ACKNOWLEDGMENT_LIST: API_PREFIX + "/acknowledgment/list",
  CANDIDATE_RESUME: API_PREFIX + "/acknowledgment/candidate-resume",
  CANDIDATE_DOWNLOAD_RESUME:
    API_PREFIX + "/acknowledgment/candidate-resume/download",
  ROLE_REQUEST_STATS: API_PREFIX + "/role-request/stats",
  RECOMMENDATION_LIST: API_PREFIX + "/recommendation/list",
  RECOMMENDATION_LIST_FOR_SCHEDULE:
    API_PREFIX + "/recommendation/list/schedule",
  INTERVIEW_SCHEDULE_CREATE: API_PREFIX + "/interview-schedule/create",
  INTERVIEW_SCHEDULE_LIST: API_PREFIX + "/interview-schedule/list",
  SHORTLISTED_LIST: API_PREFIX + "/feedback/shortlisted-list",
  FEEDBACK_CREATE: API_PREFIX + "/feedback/create",
  DOCUMENT_DOWNLOAD: API_PREFIX + "/document/download",
  ONBOARDING_LIST: API_PREFIX + "/onboarding/list",
  ONBOARDING_EXPIRING_LIST: API_PREFIX + "/onboarding/list/expiry",

  ONBOARDING_VIEW_RITM: API_PREFIX + "/onboarding/view",
  RITM_UPDATE: API_PREFIX + "/onboarding/update",
  PERFORMANCE_REPORT_SUMMARY: API_PREFIX + "/report/performance/summary",
  PERFORMANCE_REPORT_DETAILED: API_PREFIX + "/report/performance/detailed",
  INTERVIEW_SCHEDULE_STATS: API_PREFIX + "/interview-schedule/stats",
  FEEDBACK_STATS: API_PREFIX + "/feedback/stats",
  USER_INFO: API_PREFIX + "/user",
  MID_CAREER_RESUMES_SCORE: API_PREFIX + "/recommendation/mid-career-request",
  MID_CAREER_REQUEST_SAVE: API_PREFIX + "/role-request/save-mid-career-request",
  RENEW_REQUEST_SAVE: API_PREFIX + "/renew-onboarding/",
  AUDIT_INFORMATION: API_PREFIX + "/dashboard/auditor-team/current-audits",
  AUDIT_TIMELINE_DETAILS:
    API_PREFIX + "/dashboard/audit-insights/timeline-view?a",
  AUDIT_OVERVIEW_GRAPH: API_PREFIX + "/dashboard/audit-overview",
  FINDS_ISSUE_CHARTDATA:
    API_PREFIX + "/dashboard/auditor-team/findings-and-issues",
  FINDS_ISSUE_TABLEDATA:
    API_PREFIX + "/dashboard/auditor-team/findings-and-issues/issue-tracking",
  AUDIT_ESCALATION: API_PREFIX + "/dashboard/auditor-team/audit-escalations",
  AUDIT_PROGRESSMETRICS:
    API_PREFIX + "/dashboard/auditor-team/audit-progress-metrics",
  AUDIT_GENERALINFO: API_PREFIX + "/dashboard/audit-insights/general-details?a",
  AUDIT_RESOURCEUTLIZATION:
    API_PREFIX + "/dashboard/auditor-team/Resource-utilization",
  SEND_REMINDER: API_PREFIX + "/email/remainder",
  GET_APPLICATIONS_LIST: API_PREFIX + "/static/audit-application",
  QA_SUGGESTION: API_PREFIX + "/audit-question/generate-ai-question",
  REPORT_REVIEW_DATA: API_PREFIX + "/audit-question/report-review-details",
  QUESTIONNAIRE_DETAILS: API_PREFIX + "/audit-question/questionnaire-status",
  QUESTIONNAIRE_MANUAL_VALIDATION:
    API_PREFIX + "/audit-question/manual-validation",
  FOLLOWUP_QUESTION: API_PREFIX + "/audit-question/generate-followup-question",
  MANUAL_REVIEW: API_PREFIX + "/audit-question/manual-review/list",
  GENERATE_NEXT_SEQUENCE_QUESTION:
    API_PREFIX + "/audit-question/generate-next-sequence-question",
  SEND_NEXT_SEQUENCE_QUESTION:
    API_PREFIX + "/audit-question/send-next-sequence-question",
  RESPONSE_ANALYSIS:
    API_PREFIX + "/dashboard/audit-analytics/organization-response-analysis",
  RESPONSE_ANALYSIS_BY_THEME:
    API_PREFIX + "/dashboard/audit-analytics/question-theme-analysis",
  RESPONSE_ANALYSIS_BY_TIME:
    API_PREFIX + "/dashboard/audit-analytics/question-response-time-analysis",
  RESPONSE_ANALYSIS_BY_AUDITEE_TIME:
    API_PREFIX + "/dashboard/audit-analytics/auditee-question-analysis",
  POLICY_COMPARISON_RESPONSE: API_PREFIX + "/policy/compare",
  GENERATE_PURPOSE_ARTIFACTS:
    API_PREFIX + "/audit-question/generate-purpose-artifacts",
  POLICY_CLAUSE_LIST: API_PREFIX + "/policy/clauses-list",
  LDAP_DETAILS: API_PREFIX + "/directory",
  DIRECTORY_UPDATE: API_PREFIX + "/directory/save",
  TEST_CONNECTION: API_PREFIX + "/directory/check/connection",
  AI_INTERACTION: API_PREFIX + "/ai-interaction",
  SAVE_AI_INTERACTION: API_PREFIX + "/ai-interaction/update",
  LLM_CONFIGURATION_LIST: API_PREFIX + "/llm-configuration/list",
  LLM_CONFIG_LIST: API_PREFIX + "/llm-configuration/list",
  LLM_CONFIG_SAVE: API_PREFIX + "/llm-configuration/save",
  LLM_CONFIG_UPDATE: API_PREFIX + "/llm-configuration/update",
  LLM_CONFIG_DELETE: API_PREFIX + "/llm-configuration/delete",
};

export const SUCCESS_MESSAGE = {
  JD_CREATE_SUCCESS_MESSAGE: "JD has been created successfullly!",
  JD_UPDATE_SUCCESS_MESSAGE: "JD has been updated successfullly!",
  JD_DELET_SUCCESS_MESSAGE: "JD deleted successfully",
  ROLE_REQUEST_ADDED_TO_CART: "Role request has been added to cart",
  ROLE_REQUEST_DELETED_FROM_CART: "Role request has been deleted from cart",
  ROLE_REQUEST_SUBMITTED_SUCCESS:
    "Role request has been submitted successfully",
  VENDOR_CREATED_SUCCESS: "Vendor has been created successfullly!",
  INTERVIEW_SCHEDULE_CREATE_SUCCESS:
    "Interview Schedule send to vendors successfully",
  FEEDABCK_CREATE_SUCCESS: "Feedback has been submitted successfully",
  RITM_UPDATE_SUCCESS: "RITM Number has been updated successfully",
  VENDOR_UPDATE_SUCCESS_MESSAGE: "Vendor has been updated successfullly!",
  VENDOR_DELET_SUCCESS_MESSAGE: "Vendor deleted successfully",
  USER_DELET_SUCCESS_MESSAGE: "User deleted successfully",
  USER_CREATED_SUCCESS: "User has been created successfullly!",

  RENEW_SAVE_SUCCESS_MESSAGE:
    "Renewal request has been sent for approval successfully!",
};

export const ERROR_MESSAGE = {
  API_ERROR_MESSAGE: "Something went wrong. Please try again later!",
  JD_RECORD_NOT_FOUND_MESSAGE: "No JD found for the role selected!",
  JD_EXISTS_ERROR_MESSAGE: "Job description already exists for this role.",
  SCHEDULE_INTERVIEW_EMPTY_ERROR:
    "Please choose atleast one candidate to schedule interview!",
  SCHEDULE_INTERVIEW_SLOTS_EMPTY_ERROR:
    "Please choose time slots for all profile!",
  FEEDBACK_COMMENTS_EMPTY: "Please provide your feedback comments.",
};

export const VALIDATION_ERROR_MESSAGE = {
  ROLE_EMPTY_ERROR: "Please choose role",
  JOB_TITLE_EMPTY_ERROR: "Please provide job title",
  JOB_DESCRIPTION_EMPTY_ERROR: "Please provide job description",
  JOB_NUMBER_OF_ROLE_EMPTY_ERROR: "Please provide number of roles",
  ROLE_EXISTS: "Role already exists in the cart",
  VENDOR_NAME_EMPTY: "Please provide name",
  VENDOR_EMAIL_EMPTY: "Please provide email",
  VENDOR_CONTACT_EMPTY: "Please provide contact number",
  FEEDBACK_EMPTY: "Please choose feedback",
  NUMBER_OF_POSITIONS_ZERO: "Please provide number of positions ",
  CONTRACT_DURATION_EMPTY: "Please choose contract duration",
  DEPARTMENT_EMPTY: "Please choose department",
};

export const API_ERROR_CODES = {
  ERR_NO_RECORD: "ERR_NO_RECORD",
};

export const INITIAL_RICHTEXT_VALUE = [
  {
    type: "paragraph",
    children: [{ text: "" }],
  },
];

export const PAGE_TEXT = {
  ACKNOWLEDGED: "Acknowledged",
  ACKNOWLEDGED_INCORRECCT: "Acknowledged without proper template",
  ACKNOWLEDGED_WITH_ATTACHMENT: "Acknowledged with attachment",
};

export const SKILL_LEVEL_OPTIONS = [
  {
    label: "Associate Consultant",
    value: "1",
  },
  {
    label: "Consultant",
    value: "2",
  },
  {
    label: "Senior Consultant",
    value: "3",
  },
];

export const CONTRACT_DURATION_OPTIONS = [
  { label: "--Select--", value: "" },
  { label: "12 Months", value: "12" },
  { label: "24 Months", value: "24" },
];

export const MONTHS: string[] = [];
MONTHS[0] = "--Select--";
MONTHS[1] = "January";
MONTHS[2] = "February";
MONTHS[3] = "March";
MONTHS[4] = "April";
MONTHS[5] = "May";
MONTHS[6] = "June";
MONTHS[7] = "July";
MONTHS[8] = "August";
MONTHS[9] = "September";
MONTHS[10] = "October";
MONTHS[11] = "November";
MONTHS[12] = "December";

export const MAXIMUM_RESULT_PER_PAGE = 5;

// export const ALLOWED_FILES = [
//   'application/msword',
//   'application/pdf',
//   'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
// ];

export const ALLOWED_FILES = ["application/pdf"];

export const ROLE_OPTIONS = [
  { value: "", label: "--Select--" },
  { value: "ADMIN", label: "ADMIN" },
  { value: "DIVISION_HEAD", label: "DIVISION HEAD" },
  { value: "USER", label: "USER" },
  { value: "HR", label: "HR" },
];

export const MID_CAREER_ROLES = ["HR", "ADMIN"];

export const AUDIT_MODES: any = [];
AUDIT_MODES[1] = "Auto Pilot";
AUDIT_MODES[2] = "Semi Automated";
AUDIT_MODES[3] = "Manual";

export const AUDIT_LEVEL: any = [];
AUDIT_LEVEL[1] = "Shallow";
AUDIT_LEVEL[2] = "Descriptive";
AUDIT_LEVEL[3] = "Moderate";
AUDIT_LEVEL[4] = "Deeper";
AUDIT_LEVEL[5] = "Deepest";

export const AUDIT_TYPE: any = [];
AUDIT_TYPE[1] = "TRMG";
AUDIT_TYPE[2] = "CCoP";
